import React from 'react';
import { 
  DocumentCheckIcon, 
  BoltIcon, 
  QrCodeIcon,
  CheckCircleIcon,
  PrinterIcon
} from '@heroicons/react/24/outline';

const FeatureShowcase = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
      {/* Invoice Creation Demo */}
      <div className="text-center">
        <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-8 mb-6 h-64 flex flex-col items-center justify-center relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-100 to-blue-200 opacity-50"></div>
          <div className="relative z-10">
            <DocumentCheckIcon className="h-16 w-16 text-blue-600 mx-auto mb-4" />
            <div className="bg-white rounded-lg shadow-lg p-4 max-w-xs">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-gray-900">Invoice Form</span>
                <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded">Live</span>
              </div>
              <div className="space-y-2">
                <div className="h-2 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-2 bg-gray-200 rounded w-3/4 animate-pulse"></div>
                <div className="h-2 bg-blue-200 rounded w-1/2 animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          Simple Interface
        </h3>
        <p className="text-gray-600">
          Clean, intuitive design that makes invoice creation effortless. No training required.
        </p>
      </div>

      {/* Real-time Submission Demo */}
      <div className="text-center">
        <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-8 mb-6 h-64 flex flex-col items-center justify-center relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-green-100 to-green-200 opacity-50"></div>
          <div className="relative z-10">
            <BoltIcon className="h-16 w-16 text-green-600 mx-auto mb-4" />
            <div className="bg-white rounded-lg shadow-lg p-4 max-w-xs">
              <div className="flex items-center mb-3">
                <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" />
                <span className="text-sm font-medium text-gray-900">FBR Submitted</span>
              </div>
              <div className="text-left space-y-1">
                <div className="flex justify-between text-xs">
                  <span className="text-gray-600">Status:</span>
                  <span className="text-green-600 font-medium">ACCEPTED</span>
                </div>
                <div className="flex justify-between text-xs">
                  <span className="text-gray-600">Time:</span>
                  <span className="text-gray-900">2.3s</span>
                </div>
                <div className="flex justify-between text-xs">
                  <span className="text-gray-600">UUID:</span>
                  <span className="text-gray-900 font-mono">ABC123...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          Real-time Submission
        </h3>
        <p className="text-gray-600">
          Submit invoices directly to FBR with instant confirmation. No delays, no hassle.
        </p>
      </div>

      {/* QR Code Generation Demo */}
      <div className="text-center">
        <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-8 mb-6 h-64 flex flex-col items-center justify-center relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-purple-100 to-purple-200 opacity-50"></div>
          <div className="relative z-10">
            <QrCodeIcon className="h-16 w-16 text-purple-600 mx-auto mb-4" />
            <div className="bg-white rounded-lg shadow-lg p-4 max-w-xs">
              <div className="flex items-center justify-between mb-3">
                <div className="text-left">
                  <div className="text-sm font-medium text-gray-900">Invoice #001</div>
                  <div className="text-xs text-gray-600">Rs. 59,000</div>
                </div>
                <div className="w-12 h-12 bg-gray-900 rounded flex items-center justify-center">
                  <div className="w-10 h-10 bg-white rounded grid grid-cols-4 gap-px p-1">
                    {[...Array(16)].map((_, i) => (
                      <div 
                        key={i} 
                        className={`${Math.random() > 0.5 ? 'bg-black' : 'bg-white'} rounded-sm`}
                      ></div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="flex items-center text-xs text-gray-500">
                <PrinterIcon className="h-3 w-3 mr-1" />
                <span>Ready to print</span>
              </div>
            </div>
          </div>
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          Auto QR Printing
        </h3>
        <p className="text-gray-600">
          Automatic QR code generation and professional invoice printing with FBR compliance.
        </p>
      </div>
    </div>
  );
};

export default FeatureShowcase;